import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';

class StringField extends Blockly.FieldTextInput {
    constructor(value: string) {
        super(value);
        this.SERIALIZABLE = true;
    }

    override initView() {
        super.initView();
        const t = (this as any).textElement_ as SVGTextElement | undefined;
        t?.classList.add('blocklyStringFieldText');
    }

    override getText(): string {
        const v = this.getValue() ?? '';
        if (v === '') return '" "';
        return `"${v}"`;
    }

    protected override render_() {
        super.render_();
        const t = (this as any).textElement_ as SVGTextElement | undefined;
        t?.classList.add('blocklyStringFieldText');

        const block = this.getSourceBlock() as Blockly.BlockSvg | null;
        if (!block) return;
        const ws = block.workspace as Blockly.WorkspaceSvg;
        if (ws?.isFlyout) {
            requestAnimationFrame(() => {
                (this as any).updateSize_?.();
                block.render();
            });
        }
    }

    override showEditor_(): void {
        super.showEditor_();
        const input = document.querySelector('.blocklyHtmlInput') as HTMLInputElement | null;
        if (input) {
            input.classList.add('blocklyStringInput');
            input.value = this.getValue() ?? '';
            input.maxLength = 30;

            const widgetDiv = input.closest('.blocklyWidgetDiv') as HTMLElement | null;
            if (widgetDiv) {
                widgetDiv.style.borderRadius = '4px';
                input.style.borderRadius = '4px';

                const fieldRect = (this as any).textElement_?.getBoundingClientRect();
                const canvasTop =
                    (this.getSourceBlock() as Blockly.BlockSvg)?.workspace?.getParentSvg()?.getBoundingClientRect()
                        ?.top ?? 0;
                if (fieldRect) {
                    widgetDiv.style.top = `${fieldRect.top - canvasTop}px`;
                }
            }
        }
    }
}

defineBlock({
    type: 'string',
    colour: CATEGORIES.variable.color,
    output: 'String',
    outputShape: 3,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'TEXT',
                    instance: () => new StringField(''),
                },
            ],
        },
    ],
});
